import { MongoObservable } from 'meteor-rxjs';
import { OrganisationRequest } from '../models/organisationRequest';

export const OrganisationRequests =
  new MongoObservable.Collection<OrganisationRequest>('organisationRequests');

OrganisationRequests.allow({
  insert: function () {
    return false;
  },
  update: function () {
    return false;
  },
  remove: function () {
    return false;
  },
});
